<template>
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="q-py-sm">
            <div v-if="isAddNewGenerator" class="crud-title">
              <translate>NEW_REGISTRATION</translate>
            </div>
            <div v-else-if="isEditGenerator" class="crud-title">
              <translate>UPDATE</translate>
            </div>
          </q-card-section>
          <q-card-section class="q-px-lg">
            <span v-if="elements.length == 1">
              <jt-dynamic-form
                ref="dynamicForm"
                :inputs="prepareInputs(elements[0].inputs)"
                :relacionamentos="elements[0].relacionamentos"
                :model="elements[0].dadosForm"
                :interface="elements[0].nmInterface"
                form-class="form dynamic"
                @search-found="selections"
                @composition-button-click="onCompositionButtonClick"
              />
            </span>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <div
      v-if="forms[0] && forms[0].buttons.length > 0"
      class="row full-width q-col-gutter-lg justify-center q-pt-md"
    >
      <div class="col-lg-2 col-md-3">
        <q-btn class="full-width" color="grey-7" @click="limparFormGenerator">
          <translate>CLEAN</translate>
        </q-btn>
      </div>
      <div
        v-for="(button, i) in forms[0].buttons"
        :key="i"
        class="col-lg-2 col-md-3"
      >
        <q-btn class="full-width" color="info" @click="actionButton(button)">
          <q-icon
            v-if="button.icon"
            :name="button.icon"
            size="18px"
            class="position-icon-filter"
          />
          {{ button.label }}
        </q-btn>
      </div>
    </div>
    <composition-multi-form-modal
      v-show="showFormBoundResidue"
      ref="boundResidue"
      titleTopBar="ADD_MORE_RESIDUE"
      addOneMoreItemButtonLabel="RESIDUE"
      :form="formConfig"
      :model="elements[0].dadosForm"
      cssname="generator-page"
      :composicaos="elements[0].dadosForm.boundResidues"
      :nr-linha-selecionada="nrLinhaSelecionada"
      :fl-main-crud-in-change="isEditGenerator"
      :fl-composicao-alteracao="editMode"
      :afterPerformItems="afterPerformItems"
      :non-changeable-fields="nonChangeableFields"
    />
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtDynamicForm, JtDataTable } from 'jtech-webcomps'
import { repository } from 'jtech'
import CompositionMultiFormModal from '../../../components/composition-multi-form-modal/CompositionMultiFormModal'
import JtDataGridSubtitle from '../../../components/jt-data-grid-subtitle/JtDataGridSubtitle'
const {
  page,
  pageTable,
  CrudLayoutSearch,
  form,
  input,
  compositions,
  composition
} = JtCrud

@Component({
  mixins: [page],
  name: 'Generator',
  components: {
    CompositionMultiFormModal,
    JtDynamicForm,
    JtDataGridSubtitle,
    JtDataTable,
    'crud-form': form,
    compositions,
    composition,
    page,
    pageTable,
    CrudLayoutSearch,
    'crud-input': input
  },
  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object,
    id: String,
    interface: String
    // name: String
  }
})
class GeneratorPage extends Vue {
  nmInterface = null
  showFormBoundResidue = false
  formConfig = null
  nrLinhaSelecionada = null
  editMode = false
  customCompositions = ['boundResidues']
  nonChangeableFields = ['residueType', 'residue']

  mounted () {
    this.nmInterface = this.elements[0].nmInterface.split('.')[1]
  }

  get isAddNewGenerator () {
    return this.nmInterface === 'gravar'
  }

  get isEditGenerator () {
    return this.nmInterface === 'alterar'
  }

  prepareInputs (_inputs) {
    this.prepareCompositionsInputs(_inputs)

    return _inputs
  }

  prepareCompositionsInputs (_inputs) {
    _inputs.forEach((_input) => {
      if (_input.model == 'person' && _input.type != 'text') {
        _input.type = 'person_search'
      }
      if (this.customCompositions.includes(_input.model)) {
        _input.allowCustomEditModal = true
      }
    })
  }

  onCompositionButtonClick (eventObject) {
    const { button: clickedButton } = eventObject
    switch (clickedButton.name) {
      case 'icAdicionarComposicao':
        this.addResidues(eventObject)
        break
      case 'icAlterarComposicao':
        this.editResidue(eventObject)
        break
      case 'icRemoveRecordOnComposition':
        this.removeResidue(eventObject)
        break
      case 'icDetalharDocument':
        this.$emit(
          'action-button',
          eventObject.button,
          eventObject.params,
          this
        )
        break
      case 'icAlterarComposicaoClient':
        this.$emit(
          'action-button',
          eventObject.button,
          eventObject.params,
          this
        )
        break
      default:
        break
    }
  }

  limparFormGenerator () {
    this.limparForm()
    this.elements[0].dadosForm = { boundResidues: [], person: null }
    this.$refs.inputs.resetValidation()
  }

  addResidues (eventObject) {
    this.editMode = false
    this.openMultiFormModal(eventObject)
  }

  editResidue (eventObject) {
    this.editMode = true
    this.nrLinhaSelecionada = eventObject.nrLinhaSelecionada
    this.openMultiFormModal(eventObject)
  }

  removeResidue (eventObject) {
    const { compositionId, params } = eventObject
    const clickedIndex =
      params && (params.__index || params.__index === 0)
        ? eventObject.params.__index
        : null
    const newResiduesArray = []
    this.elements[0].dadosForm[compositionId].forEach((residue) => {
      const isAlreadyASavedRecord = residue.id || residue.id === 0
      if (isAlreadyASavedRecord || residue.__index !== clickedIndex) {
        residue.__index = newResiduesArray.length
        newResiduesArray.push(residue)

        if (residue.__index === clickedIndex && isAlreadyASavedRecord) {
          console.error(
            'This button can\'t be used when the process is different from add a new generator'
          )
        }
      }
    })
    this.elements[0].dadosForm[compositionId] = newResiduesArray
    this.nrLinhaSelecionada = null
  }

  openMultiFormModal (eventObject) {
    const { compositionId, formConfig } = eventObject

    if (this.customCompositions.includes(compositionId)) {
      this.formConfig = formConfig

      if (compositionId === 'boundResidues') {
        this.showFormBoundResidue = true
      }

      this.$nextTick(() => {
        this.$refs[compositionId.substring(0, compositionId.length - 1)].show()
      })
    }
  }

  afterPerformItems () {
    this.showFormBoundResidue = false
    this.$refs.boundResidue.hide()
  }

  async selections (data) {
    const { person, available } = this.elements[0].dadosForm

    if (data.person.idField) {
      const param = { id: data.person.idField }
      const { registros } = await repository.resolveDatatableModel(
        'person.pesquisarSelecao',
        param
      )
      delete registros[0].id
      delete registros[0].idAcaoGrid

      this.elements[0].dadosForm = {
        ...this.elements[0].dadosForm,
        ...registros[0]
      }
    } else {
      this.elements[0].dadosForm = {
        person,
        available
      }
    }
  }
}
export default GeneratorPage
</script>

<style lang="stylus" >
.containerForm-add {
  height: 190px !important;
  padding: 25px 25px;
  }

  .composition-multi-form-modal .containerForm {
  margin-top: 20px;
}
</style>
